import React, { useState } from "react";
import "./RenderStyle.css";
import PaymentsDetails from "./PaymentsDetails";
import { ScrollX_250, ScrollX_limited } from "../../../assets/icons";

const UpgradePlan = ({
  isUpgradeOpen,
  IsUpgradeOpen,
  renderPlan,
  currentPlanDetails,
  remainingDays,
  setRenderOpen,
  planPurchaseDate,
  expirationMessage,
  getTime,
  setIsSuccessOpen,
  paymentType,
  order_id,
  subscription_status
}) => {
  
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [currentPlanRange, setCurrentPlanRange] = useState({
    start: 0,
    end: 2,
  });

  const goToNextPlan = () => {
    if (currentPlanRange.end < renderPlan.length - 1) {
      setCurrentPlanRange({
        start: currentPlanRange.start + 1,
        end: currentPlanRange.end + 1,
      });
    }
  };

  const goToPreviousPlan = () => {
    if (currentPlanRange.start > 0) {
      setCurrentPlanRange({
        start: currentPlanRange.start - 1,
        end: currentPlanRange.end - 1,
      });
    }
  };
  return (
    <>
      <div>
        {isUpgradeOpen === true && (
          <div className={`UpgradePlan-modelcontainer `}>
            <div
              className="UpgradePlan-overlay"
              onClick={() => IsUpgradeOpen(true)}
              style={{ color: "#000" }}
            ></div>
            <div className="UpgradePlan-content">
              <div
                className="w-full py-[4%]"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <div className="w-full  pb-[4%]  flex justify-center items-center">
                  <div className="text-center">
                    <h3
                      className="text-3xl font-bold Syne700 py-2 tracking-wide text-white"
                      
                    >
                      Choose the plan that fits you best
                    </h3>
                    <p className="text-base FontFamily-Avenir-reg tracking-wide text-white">Projects stay forever, but renders shine during your subscription.</p>
                  </div>
                  <div>
                    <span
                      className="close-button"
                      onClick={() => IsUpgradeOpen(false)}
                    >
                      &#10005;
                    </span>
                  </div>
                </div>

                <div className="flex justify-center items-center py-[2%] w-[75%] planblockDIV">
                  {renderPlan
                    .slice(currentPlanRange.start, currentPlanRange.end + 1)
                    .map((plan, ind) => (
                      <div
                        className={`page5paydiv2 cursor-pointer ${ind === 1 ? "active" : ""}`}
                        key={`upg${ind + 1}`}
                        onClick={() => {
                          setSelectedPlan(plan);
                          setIsOpen(true);
                        }}                
                      >
                        <div className="relative">
                        <img className={`imageScrollLimited ${ind === 1 ? "active" : ""}`}  src={ScrollX_limited} alt="" />

                        </div>
                        <div className={`priceBlock1 w-full ${ind === 1 ? "active" : ""}`}>
                          <img className={`image250 ${ind === 1 ? "active" : ""}`} src={ScrollX_250} alt="" />
                          <h1
                         
                          className="priceheading1  "
                          style={{
                            fontFamily: "Avenir book",
                            fontWeight: "bold",
                            textDecoration: "none",
                            color: "white",
                          }}
                        >
                          {plan?.currency + plan?.price}
                        </h1>
                        <h3
                        className={`Syne700  priceheading3 ${ind === 1 ? "active" : ""}`}
                          style={{
                            fontWeight: "bold",
                            textDecoration: "none",
                            color: "white",
                          }}
                        >
                          {plan?.type}
                        </h3>
                        <div
                         className={`PricePlanbottom ${ind === 1 ? "active" : ""}`}
                          style={{
                            borderBottom: "1px solid #3a3755",
                            width: "80%",
                          }}
                        />
                        <div
                         className={` priceheading2 ${ind === 1 ? "active" : ""}`}
                         
                          style={{
                            fontFamily: "Avenir book",
                            fontWeight: "normal",
                            textDecoration: "none",
                            color: "white",
                          }}
                        >
                          {plan?.text1} <br />
                          {plan?.text2}
                          <br />
                          <span className="font-bold">{plan?.validity}</span>
                        </div>
                        <div
                         className={` priceheading4 pb-[1.5rem] ${ind === 1 ? "active" : ""}`}
                          style={{
                            fontFamily: "Avenir book",
                            fontWeight: "normal",
                            textDecoration: "none",
                            color: "white",
                          }}
                        >
                          {plan?.text3} <br />
                          {plan?.text4} <br />
                          Alpha Transparency
                        </div>
                        </div>
                        
                        {/* <div className="pt-2 ">
                          <button
                          className={`font-bold text-xl priceUpgradeBTN ${ind === 1 ? "active" : ""}`}
                            
                           
                            style={{
                              fontFamily: "Avenir book",
                              backgroundColor: "#1c467d",
                              borderRadius: "50px",
                              color: "white",
                              padding: "7px 35px",
                              textDecoration: "none",
                            }}
                          >
                            Upgrade
                          </button>
                        </div> */}
                        <div
                         className={`priceLimitedtime ${ind === 1 ? "active" : ""}`}
                        >
                          **limited time 20% off
                        </div>
                      </div>
                    ))}

                  {/* <div className="page5paydiv3" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '55vh', backgroundColor: '#9d7e4e', textAlign: 'center', borderRadius: '10px', padding: '50px 20px', position: 'relative' }}>
                                        <img className="w-10" src={Tik_icon_logo} alt="" style={{ position: 'absolute', top: '-5px', left: '-5px' }} />
                                        <h1 className="" style={{ fontFamily: 'Avenir book', fontSize: '3rem', fontWeight: 'bold', textDecoration: 'none', color: '#b6b1ad' }}>$99</h1>
                                        <h3 className="" style={{ fontFamily: 'Syne", sans-serif', fontSize: '1.5rem', fontWeight: 'bold', textDecoration: 'none', color: '#b6b1ad' }}>FAST</h3>
                                        <div className="" style={{ borderBottom: '1px solid #e1e1e1', width: '100%' }} />
                                        <div className="" style={{ fontFamily: 'Avenir book', fontSize: '1rem', fontWeight: 'normal', textDecoration: 'none', textDecoration: 'none', color: '#b6b1ad' }}>Unlimited Renders <br /> Unlimited Projects<br />For 7 Days</div>
                                        <div className="" style={{ fontFamily:  'Avenir book', fontSize: '1rem', fontWeight: 'normal', textDecoration: 'none', textDecoration: 'none', color: '#b6b1ad' }}>4K renders <br />ProRes 4444, H264</div>
                                        <div>
                                            <button className="" onClick={() => setIsOpen(true)} style={{ backgroundColor: '#1c467d', borderRadius: '50px', color: '#b6b1ad', padding: '4px 20px 8px', textDecoration: 'none' }}>Upgrade</button>
                                        </div>
                                    </div>

                                    <div className="page5paydiv4" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '50vh', backgroundColor: '#5a472d', textAlign: 'center', borderRadius: '10px', padding: '50px 20px' }}>
                                        <h1 className="" style={{ fontFamily: 'Avenir book', fontSize: '3rem', fontWeight: 'bold', textDecoration: 'none', color: '#b6b1ad' }}>$99</h1>
                                        <h3 className="" style={{ fontFamily: 'Syne", sans-serif', fontSize: '1.5rem', fontWeight: 'bold', textDecoration: 'none', color: '#b6b1ad' }}>FAST</h3>
                                        <div className="" style={{ borderBottom: '1px solid #e1e1e1', width: '100%' }} />
                                        <div className="" style={{ fontFamily: 'Avenir book', fontSize: '1rem', fontWeight: 'normal', textDecoration: 'none', textDecoration: 'none', color: '#b6b1ad' }}>Unlimited Renders <br /> Unlimited Projects<br />For 7 Days</div>
                                        <div className="" style={{ fontFamily: 'Avenir book', fontSize: '1rem', fontWeight: 'normal', textDecoration: 'none', textDecoration: 'none', color: '#b6b1ad' }}>4K renders <br />ProRes 4444, H264</div>
                                        <div>
                                            <button className="" onClick={() => setIsOpen(true)} style={{ backgroundColor: '#1c467d', borderRadius: '50px', color: '#b6b1ad', padding: '4px 20px 8px', textDecoration: 'none' }}>Upgrade</button>
                                        </div>
                                    </div> */}
                </div>
                {/* <button className="prev-button" onClick={goToPreviousPlan} disabled={currentPlanRange.start === 0}>
                  <span>&lt;</span>
                </button>
                <button className="next-button" onClick={goToNextPlan} disabled={currentPlanRange.end === renderPlan.length - 1}>
                  <span>&gt;</span>
                </button> */}
              </div>
              {isOpen && (
                <PaymentsDetails
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  selectedPlan={selectedPlan}
                  IsUpgradeOpen={IsUpgradeOpen}
                  currentPlanDetails={currentPlanDetails}
                  remainingDays={remainingDays}
                  setRenderOpen={setRenderOpen}
                  planPurchaseDate={planPurchaseDate}
                  expirationMessage={expirationMessage}
                  getTime={getTime}
                  setIsSuccessOpen={setIsSuccessOpen}
                  paymentType={paymentType}
                  order_id={order_id}
                  subscription_status={subscription_status}
                />
              )}
            </div>

            {/* =========================================================================================================================================== */}
          </div>
        )}
      </div>
    </>
  );
};

export default UpgradePlan;